// apps/app/src/features/chat/Messages/Item/Reactions.tsx
import { IconButton } from '@/components/ui/icon-button'
import { Text } from '@/components/ui/text'
import type { MessageReaction } from '@hvf/contracts'
import { userId } from '@stateApp'
import { For, Show } from 'solid-js'
import { css } from 'styled-system/css'
import { Box, Flex } from 'styled-system/jsx'

type Reaction = Pick<MessageReaction, 'emoji' | 'created_by'>

interface ReactionsProps {
  reactions?: Reaction[]
  onReaction: (emoji: string) => void
}

export default function (props: ReactionsProps) {
  const reactionsDictionary = () => {
    const reactionMap: Record<string, Reaction & { count: number; isMine: boolean }> = {}
    const currentUserId = userId()

    for (const reaction of props.reactions || []) {
      if (reactionMap[reaction.emoji]) {
        reactionMap[reaction.emoji].count++
        if (reaction.created_by === currentUserId) {
          reactionMap[reaction.emoji].isMine = true
        }
      } else {
        reactionMap[reaction.emoji] = {
          emoji: reaction.emoji,
          count: 1,
          created_by: reaction.created_by,
          isMine: reaction.created_by === currentUserId,
        }
      }
    }

    return Object.values(reactionMap)
  }

  return (
    <Show when={props.reactions?.length}>
      <Flex gap="6px" flexWrap="wrap">
        <For each={reactionsDictionary()}>
          {(reaction) => (
            <IconButton
              class={css({ height: 'auto', minWidth: 0 })}
              style={{
                display: 'inline-flex',
                'align-items': 'center',
                gap: '5px',
                padding: '3px 9px',
                'border-radius': '999px',
                border: `1px solid ${reaction.isMine ? 'var(--colors-editorial-accent)' : 'var(--colors-editorial-hair-strong)'}`,
                background: reaction.isMine ? 'color-mix(in srgb, var(--colors-editorial-accent) 10%, transparent)' : 'transparent',
              }}
              size="xs"
              variant="plain"
              type="button"
              onClick={() => props.onReaction(reaction.emoji)}
            >
              <Box fontSize="12px" lineHeight="1">{reaction.emoji}</Box>
              <Text
                fontSize="11px"
                color="editorialInk2"
              >
                {reaction.count <= 0 ? '' : reaction.count}
              </Text>
            </IconButton>
          )}
        </For>
      </Flex>
    </Show>
  )
}
